import { startOfWeek, addDays, isSameDay, endOfWeek } from "date-fns";
import DayColumn from "./DayColumn";
import ProgressBar from "./ProgressBar";
import { useTasksForPeriod } from "../hooks/useTasks";
import { useAuth } from "../contexts/AuthContext";

export default function WeekCard() {
  const today = new Date();
  const { isDemoMode, user } = useAuth();
  const weekStart = startOfWeek(today, { weekStartsOn: 1 }); // Monday
  const weekEnd = endOfWeek(today, { weekStartsOn: 1 });
  const { tasks: weekTasks } = useTasksForPeriod(weekStart, weekEnd, isDemoMode, user?.uid);

  const completedCount = weekTasks.filter((t) => t.completed).length;
  const progress =
    weekTasks.length > 0
      ? Math.round((completedCount / weekTasks.length) * 100)
      : 0;

  const weekDays = Array.from({ length: 5 }, (_, i) => addDays(weekStart, i));

  return (
    <div className="bg-[#202020] rounded-3xl px-3 md:px-6 pt-3 md:pt-6 pb-0 flex flex-col shadow-[9px_9px_15px_rgba(0,0,0,0.4)]">
      <div className="bg-amber-600 rounded-t-3xl -mx-3 md:-mx-6 -mt-3 md:-mt-6 mb-3 md:mb-4 p-3 md:p-4">
        <h2 className="text-white text-base md:text-xl font-bold text-center uppercase">
          Week
        </h2>
      </div>

      <div className="grid grid-cols-5 md:flex gap-1.5 md:gap-3 mb-3 md:mb-4 flex-grow items-start auto-rows-auto">
        {weekDays.map((day) => (
          <DayColumn
            key={day.toISOString()}
            date={day}
            isToday={isSameDay(day, today)}
          />
        ))}
      </div>

      <div className="mt-auto pb-3 md:pb-0">
        <ProgressBar percentage={progress} label="Weekly Progress:" />
      </div>
    </div>
  );
}
